/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { UpgradeStrService } from '../upgrade-str.service';
import { UploadFailDetailModule } from '../upload-fail-detail/upload-fail-detail.module';
import { UpgradeFileUploadComponent } from './file-upload.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CoreModule,
        FormsModule,
        UploadFailDetailModule,
    ],
    declarations: [
        UpgradeFileUploadComponent,
    ],
    providers: [
        UpgradeFileUploadComponent,
        UpgradeStrService,
    ],
    exports: [UpgradeFileUploadComponent],
})
export class UpgradeFileUploadModule { }
